import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthSession } from "../../features/auth/shared";

interface RouteGuardProps {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
}

const ROLE_HOME_PATHS: Record<string, string> = {
  merchant: "/merchant/home",
  super_admin: "/dashboard",
  admin: "/dashboard",
  developer: "/dashboard",
};

export const RouteGuard: React.FC<RouteGuardProps> = ({
  children,
  allowedRoles,
  redirectTo = "/login",
}) => {
  const { user, isLoggedIn } = useAuthSession();

  if (!isLoggedIn || !user) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  if (!allowedRoles.includes(user.role)) {
    const fallbackPath = ROLE_HOME_PATHS[user.role] ?? "/login";
    return (
      <Navigate
        to={fallbackPath}
        replace
      />
    );
  }

  return <>{children}</>;
};
